import { CommonModule, registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AdditionalsModule } from './additionals/additionals.module';
import { DriverModule } from './driver/driver.module';
import { HomeModule } from './home/home.module';
import { PagesRoutingModule } from './pages-routing.module';
import { PersonModule } from './person/person.module';
import { SuccessModule } from './success/success.module';
import { VehiclesModule } from './vehicles/vehicles.module';
import { PaymentModule } from './payment/payment.module';
import { ReservationModule } from './reservation/reservation.module';

registerLocaleData(ptBr);
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HomeModule,
    PersonModule,
    SuccessModule,
    PagesRoutingModule,
    PaymentModule,
    ReservationModule
  ],
  exports: [PagesRoutingModule],
  providers: [{ provide: LOCALE_ID, useValue: 'pt' }],
})
export class PagesModule {}
